import { SizeChartUI } from "./SizeChartUI";
import { StandardProps } from "../componentMap";
import { cleanHtml } from "@/utils/string/cleanHtml";
import { recordImpressionByParam } from "@JohnLewisPartnership/experiments-utils";
import { useEffect } from "react";
import { useMonetateId } from "@/hooks/useMonetateId/useMonetateId.ts";

export function SizeChart({
  product,
  runtimeConfig,
  experiencesRawObject,
}: Pick<StandardProps, "product" | "runtimeConfig" | "experiencesRawObject">) {
  const { monetateId } = useMonetateId();
  const sizeInfoExcludedCategory = product?.browsePageHierarchy?.find(
    (bph) =>
      bph.name?.toLowerCase().indexOf("jewellery") > -1 ||
      bph.name?.toLowerCase().indexOf("watches") > -1,
  );
  const sizeGuideContent =
    cleanHtml((product.sizeGuide || "").replace(/_x000D_/g, "")) || "";

  const showSizeChartInfo = !sizeInfoExcludedCategory && sizeGuideContent;

  const handleRecordImpression = (impressionStatus: boolean) => {
    recordImpressionByParam(
      runtimeConfig?.monetateEnvironment,
      experiencesRawObject as [],
      "pdp-scaffold-size-chart-displayed",
      impressionStatus.toString(),
      monetateId,
    );
  };

  useEffect(() => {
    handleRecordImpression(false);
  }, []);

  return showSizeChartInfo ? (
    <SizeChartUI
      sizeGuideContent={sizeGuideContent}
      handleRecordImpression={handleRecordImpression}
    />
  ) : null;
}
